if (!customElements.get('custom-sales-rocket-fbt')) {
  class CustomSalesRocketFbt extends HTMLElement {
    constructor () {
      super();
      this.observer = new MutationObserver(this.observerCallback.bind(this));
      this.observerConfig = { subtree: true, childList: true };
      this.container = this.querySelector('div:first-child');
    }

    customCheckBox (value) {
      const root = document.createElement('label');
      root.classList.add('custom-controls');
      const span = document.createElement('span');
      span.classList.add('fbt-custom-checkbox');
      const element = document.createElement('input');
      element.type = 'checkbox';
      element.value = `${value}`;
      element.checked = true;
      element.name = 'custom-control';
      root.append(element);
      root.append(span);
      return root;
    }

    controlChangeHandle (e) {
      const id = e.target.value;
      const checked = e.target.checked;
      const control = this.container.querySelector('.fbt-shopper-items input[data-product="' + id + '"]');
      if (control) {
        control.checked = checked;
        control.dispatchEvent(new Event('change'));
      }
    }

    handleButtonClick (e) {
      e.preventDefault();
      e.stopPropagation();

      let formData = {
        items: [],
      };
      const items = this.container.querySelectorAll('.fbt-shopper-items > li[data-product]');
      items.forEach((item) => {
        const checkbox = item.querySelector('.fbt-shopper-item-checkbox');
        if (checkbox && checkbox.checked) {
          const variantSelector = item.querySelector('.fbt-shopper-variant-select');
          const quantitySelector = item.querySelector('.fbt-quantity-control-input');
          if (variantSelector) {
            const variant = variantSelector.value;
            const quantity = quantitySelector ? quantitySelector.value : 1;
            if (variant) {
              formData.items.push({
                id: variant,
                quantity: quantity,
              });
            }
          }
        }
      });
      if (!formData.items.length) {
        e.target.dispatchEvent(new Event('click'));
      } else {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }).then(response => {
          return response.json();
        }).catch((error) => {
          console.error('Error:', error);
        });
        e.target.addEventListener('click', (clickEvent) => {
          clickEvent.stopImmediatePropagation();
        }, { once: true });
        e.target.addEventListener('submit', (clickEvent) => {
          clickEvent.stopImmediatePropagation();
        }, { once: true });
        return false;
      }
    }

    observerCallback (mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (this.container?.id === mutation?.target?.id) {
            const nodes = mutation.addedNodes[0];
            const button = nodes.querySelector('.fbt-shopper-add-selected-to-cart');
            const title = nodes.querySelector('.fbt-shopper-offerTitle');
            if(title) {
              title.style.display='none';
              const heading = document.createElement('h2');
              heading.innerText = title.innerHTML;
              heading.classList.add('global-section-heading');
              title.replaceWith(heading);
            }
            if (button) {
              const newButton = button.cloneNode(true);
              newButton.classList.add('custom');
              newButton.classList.add('advanced-button');
              button.parentNode.replaceChild(newButton, button);
              this.container.querySelector('.fbt-shopper-add-selected-to-cart').addEventListener('pointerdown', this.handleButtonClick.bind(this));
            }
            const cards = nodes.querySelectorAll('.fbt-shopper-images > li[data-product]');
            cards.forEach((item) => {
              item.appendChild(this.customCheckBox(item.dataset.product));
              item.querySelector('input[name="custom-control"]').
                addEventListener('change', this.controlChangeHandle.bind(this));
            });
            const controls = nodes.querySelectorAll('.fbt-shopper-items > li[data-product]');
            controls.forEach((item) => {
              const id = item.dataset.product;
              if (id) {
                const related = this.container.querySelector('.fbt-shopper-images > li[data-product="' + id + '"]');
                if (related) {
                  const label = item.querySelector('.fbt-shopper-item-label');
                  if (label) {
                    const labelHTML = label.innerHTML;
                    const root = document.createElement('div');
                    root.classList.add('custom-product-info');
                    root.innerHTML = labelHTML;
                    root.querySelectorAll('*[id]').forEach((item) => {
                      item.setAttribute('data-replaced-id', item.id);
                      item.removeAttribute('id');
                    });
                    related.appendChild(root);
                    related.querySelector('input').checked = item.querySelector('input').checked;
                  }

                }
              }
            });
          } else if (mutation.target.classList.contains('fbt-shopper-item-price')) {
            const id = mutation.target.id;
            if (id && this.container.querySelector('*[data-replaced-id="' + id + '"]')) {
              const html = mutation.target.innerHTML;
              const currency = mutation.target.querySelector('[data-shopper-cc-current]');
              if (currency) {
                html.replaceAll(currency, '');
              }
              this.container.querySelector('*[data-replaced-id="' + id + '"]').innerHTML = mutation.target.innerHTML;
            }
            this.style.opacity = 1;
          }
        }
      });
    }

    disconnectedCallback () {
      if (this.container) {
        this.observer.disconnect();
        const button = this.container.querySelector('.fbt-shopper-add-selected-to-cart');
        if (button) {
          button.removeEventListener('pointerdown', this.handleButtonClick.bind(this));
        }
        this.container.querySelectorAll('.fbt-shopper-images > li[data-product] input[name="custom-control"]').
          forEach((item) => {
            item.querySelector('input[name="custom-control"]').
              removeEventListener('change', this.controlChangeHandle.bind(this));
          });

      }
    }

    connectedCallback () {
      if (this.container) {
        this.observer.observe(this.container, this.observerConfig);
      }
    }
  }

  customElements.define('custom-sales-rocket-fbt', CustomSalesRocketFbt);
}